<template>
  <div>
    <div class="">
      <carousel ref="carouselSelector" :navigationEnabled="false" :pagination-enabled="true" :loop="true"
        :autoplay="true" :perPage="1" :autoplayTimeout="2000" :pauseOnOver="false">
        <slide v-for="(item, index) in items" :key="index">
          <div :style="
            'background-image:linear-gradient(180deg, rgba(0, 0, 0, 0) 43.23%, rgba(0, 0, 0, 0.72) 100%), url(' +
            item.image +
            ');'
          " class="ui-image--cover blog__gallery-image"></div>
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
import {Carousel, Slide} from "vue-carousel"
export default {
  props: ["items"],
  data() {
    return {
      width: screen.width
    }
  },
  components: {
    Carousel,
    Slide
  },
  methods: {
    navigateTo(index) {
      this.slider = index
      this.$refs.carouselSelector.goToPage(index);
    },
  },
  mounted() {
    setTimeout(() => {
      this.$refs['carouselSelector'].onResize();
      this.$refs['carouselSelector'].goToPage(0);
    }, 200);
  }
}
</script>

<style lang="scss">
.VueCarousel-dot--active {
  background-color: rgb(111, 57, 255) !important;
}
</style>